import React from "react";
import Navbar from "../components/common/navbar";
import ProductImage from "../components/product/productImage";
import ProductList from "../components/home/productList";
import Footer from "../components/common/footer";

const ProductPage = () => {
  return (
    <div>
      <Navbar />
      <div className="md:mx-12 mb-20">
        <ProductImage />
        <ProductList />
      </div>
      <Footer/>
    </div>
  );
};

export default ProductPage;
